import { trackLink } from '@vfit/shared/data-access';
import { IConsentItem, IPartyPrivacyItem } from '@vfit/shared/models';
import { useCallback, useEffect, useState, useRef } from 'react';

export const useConsentsHook = (
  partyPrivacyItems: IConsentItem[],
  onUpdateConsents: (consents: IConsentItem[]) => void
) => {
  const DEFAUL_MODAL_DATA = {
    isOpen: false,
    consent: {
      id: '',
      subscribers: [],
    },
  };

  const [localConsentList, _setLocalConsentList] = useState<IPartyPrivacyItem[]>(partyPrivacyItems);
  const [modalConfig, setModalConfig] = useState<{
    isOpen: boolean;
    consent: IPartyPrivacyItem;
  }>(DEFAUL_MODAL_DATA);

  const localConsentListRef = useRef(localConsentList);

  const setLocalConsentList = (updatedList: IPartyPrivacyItem[]) => {
    localConsentListRef.current = updatedList;
    _setLocalConsentList(updatedList);
  };

  const getConsentTracking = (consentList: IPartyPrivacyItem[]) => {
    let trackLinkName = '';
    consentList.forEach(
      (consent, index) =>
        (trackLinkName = trackLinkName.concat(
          `${index + 1};${consent.selectedValue ? '1' : '0'}${
            index + 1 < consentList.length ? ',' : ''
          }`
        ))
    );
    return trackLinkName;
  };

  const handleCloseModal = useCallback(() => {
    setModalConfig(DEFAUL_MODAL_DATA);
  }, []);

  const handleOpenModal = (consent: IPartyPrivacyItem) => {
    trackLink(consent.name?.toLowerCase() || '');
    setModalConfig({
      isOpen: true,
      consent,
    });
  };

  const handleChangeConsent = (changedConsent: IPartyPrivacyItem) => {
    setLocalConsentList(
      localConsentList.map((consent: IPartyPrivacyItem) => {
        if (changedConsent.id === consent.id) {
          return { ...consent, selectedValue: !consent.selectedValue };
        }
        return consent;
      })
    );
  };

  const handleNextButtonClick = (event: Event) => {
    trackLink(getConsentTracking(localConsentListRef.current));
    onUpdateConsents(localConsentListRef.current);
  };

  useEffect(() => {
    const goNextButton = document.getElementById('sticky-offer-next');
    goNextButton?.addEventListener('click', handleNextButtonClick);
    return () => {
      goNextButton?.removeEventListener('click', handleNextButtonClick);
    };
  }, []);

  return {
    modalConfig,
    localConsentList,
    setModalConfig,
    handleOpenModal,
    handleCloseModal,
    handleChangeConsent,
  };
};

